import { createSelector } from 'reselect';
import first from 'lodash/first';
import values from 'lodash/values';
import {
    eventsCardInfoLookup,
    getSearchContent,
    getSearchSection,
} from '../../../../../utils/general';
import { hasEventResults as hasEventResultsShared } from '../../../utils/events';

const _getMaxPage = ({ event }) => {
    const firstKey = first(Object.keys(event));

    let pageCount;

    if (event[firstKey]) {
        pageCount = event[firstKey].pageCount;
    }

    return pageCount;
};

const getSuggestedRawEvents = (state) => state.suggestions.rawEvents;
const getEntities = (state) => state.content.entities;
const getPagination = (state) => state.pagination;
const getCurrencyFormat = (state) => state.currencyFormat;
const getIsOnline = (state) => state.location.isOnline;

const getSearchSectionSelector = createSelector([getIsOnline], (isOnline) =>
    getSearchSection(isOnline),
);

const getEventResults = createSelector(
    [getEntities, getPagination, getCurrencyFormat, getSearchSectionSelector],
    (entities, pagination, currencyFormat, section) =>
        getSearchContent(entities, pagination, currencyFormat, section),
);

export const hasEventResults = createSelector([getEventResults], (results) =>
    hasEventResultsShared(results),
);

export const isNextDisabled = createSelector([getPagination], (pagination) => {
    const pageCount = _getMaxPage(pagination);
    const { currentPage } = pagination;

    return currentPage === pageCount - 1;
});

export const getEventSuggestions = createSelector(
    [getSuggestedRawEvents, getCurrencyFormat, getSearchSectionSelector],
    (rawEvents, currencyFormat, section) => {
        const events = values(rawEvents);

        return eventsCardInfoLookup({
            bucketsContent: events,
            currencyFormat,
            section,
        });
    },
);
